import { PlusIcon, MinusIcon } from "@phosphor-icons/react";

import { IconButton } from "@/components/IconButton/IconButton";

interface CounterProps {
  value: number;
  step?: number;
  maxValue?: number;
  minValue?: number;
  plusButtonAriaLabel?: string;
  minusButtonAriaLabel?: string;
  plusButtonDisabled?: boolean;
  minusButtonDisabled?: boolean;
  onChange: (newValue: number) => void;
}

export function CounterButton({
  value,
  step = 1,
  maxValue,
  minValue = 0,
  plusButtonAriaLabel,
  minusButtonAriaLabel,
  plusButtonDisabled,
  minusButtonDisabled,
  onChange,
}: CounterProps) {
  const minusDisabled = minusButtonDisabled || value <= minValue;
  const plusDisabled =
    plusButtonDisabled || (maxValue != null && value >= maxValue);

  return (
    <div className="flex w-fit items-center gap-2 text-text-primary">
      <IconButton
        onClick={() => onChange(Math.max(value - step, minValue))}
        disabled={minusDisabled}
        type="button"
        aria-label={minusButtonAriaLabel ?? "-"}
        color="accent-bordered"
        size="small"
      >
        <MinusIcon size={16} color="currentColor" />
      </IconButton>

      <span className="flex w-8 justify-center text-text-primary">{value}</span>

      <IconButton
        onClick={() => {
          const newValue = value + step;
          onChange(maxValue != null ? Math.min(newValue, maxValue) : newValue);
        }}
        disabled={plusDisabled}
        type="button"
        aria-label={plusButtonAriaLabel ?? "+"}
        color="accent-bordered"
        size="small"
      >
        <PlusIcon size={16} color="currentColor" />
      </IconButton>
    </div>
  );
}
